import axios from '@/request/axios'
import { agent } from '@/request/api'

const state = {
  list: []
}

const mutations = {
}

const actions = {
  //  收益列表
  list ({}, data) {
    return axios.postFromDataRequest(agent.income, data)
  },
  //  生成收益
  add ({}, data) {
    return axios.postFromDataRequest(agent.addIncome, data)
  },
  // 批量生成收益
  batchAdd ({}, data) {
    return axios.postFromDataRequest(agent.batchAddIncome, data)
  },
  //  更新收益
  statistics({}, data) {
      return axios.postFromDataRequest(agent.statistics, data)
  },
  //  轧差收益
  netting ({}, data) {
    return axios.postFromDataRequest(agent.nettingIncome, data)
  },
  //  撤销收益收益
  del ({}, data) {
    return axios.postFromDataRequest(agent.delIncome, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/income.js